export default {
	start: {
		title: "AI-платформа",
		tips: "Преврати прокрутку в доход! Ежедневный вывод в одно касание – твой телефон, твоя денежная машина!"
	},
	login: {
		tips: "Нет аккаунта?",
		Signup: "Зарегистрироваться",
		logIn: "Войти",
		Remember: "Запомнить меня",
		form: {
			label: ["Имя пользователя/Телефон", "Пароль"]
		},
		forgotPassword: "Забыли пароль?",
		contactSupport: "Связаться с поддержкой",
		title: "Создать аккаунт",
		content: ["Нужен аккаунт?", "Создайте его здесь"]
	},
	register: {
		form: {
			label: [
				"Имя пользователя",
				"Телефон",
				"Пароль для транзакций",
				"Пароль для входа",
				"Подтвердите пароль",
				"Пол",
				"Код приглашения",
				"Электронная почта",
				"Код подтверждения"
			],
			rule: {
				Username: "Имя пользователя должно содержать от 4 до 10 символов",
				Email: "Введите действующий адрес электронной почты",
				Phone: "Номер телефона должен быть не менее 4 цифр",
				ConfirmLoginPassword: "Пароли не совпадают",
				TradingPassword: "Пароль для транзакций должен быть не менее 6 символов",
				LoginPassword: "Пароль для входа должен быть не менее 6 символов"
			}
		},
		sendMsg: "Код отправлен! Проверьте сообщение.",
		agree: ["Я соглашаюсь с {0}", "Политикой конфиденциальности, MSA", "и", "Условиями использования"],
		content: [
			"Создайте бесплатный аккаунт",
			"Уже есть аккаунт?",
			"Войти здесь",
			"Создать аккаунт",
			"Продолжая, вы соглашаетесь с нашими"
		]
	}
};
